import React, { useState } from "react";
import { useContext } from "react";
import { Navbar, Nav, Dropdown } from "react-bootstrap";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { Context } from "../Utility/ContextManager";
import { LOGO } from "../Utility/static";
import { logOut } from "../Utility/index";
import { useconfirmAlert } from "../Utility/Confirmation";
import { SpinnerLoading } from "./Loadings";

export default function LeftNavbar() {
  const { pathname } = useLocation();
  const navigation = useNavigate();
  const { user, forteMappingData } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const isForteEnabled = forteMappingData !== null && forteMappingData !== undefined;

  const signOut = async () => {
    useconfirmAlert({
      onConfirm: () => {
        setLoading(true);
        logOut().finally(() => setLoading(false));
      },
      title: "Are sure you want to logout?",
    });
  };

  const MobileHeader = () => (
    <header className="d-lg-none">
      <Navbar fixed="top" expand="lg">
        <div className="header-wrapper">
          <Navbar.Brand as={Link} to="/Dashboard">
            <img src={require("../assets/images/logo.svg").default} alt="" width={40} height={40} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <img src={require("../assets/images/toggle-icon.svg").default} alt="toggle" />
          </Navbar.Toggle>
        </div>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="leftmenu mb-2 mb-md-0" as="ul">
            <Nav.Item as="div" className={`${pathname === "/MyAccount" && "active"}`}>
              <div className="user-info d-flex">
                <img
                  src={
                    user?.profile_picture ? user.profile_picture : require("../assets/images/profileDummy.png").default
                  }
                  alt=""
                  className="rounded-circle"
                />
                <Dropdown drop="end">
                  <Dropdown.Toggle>
                    {user?.first_name} {user?.last_name}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigation("/MyAccount")}>
                      <img src={require("../assets/images/account-icon.svg").default} alt="" />
                      My Account
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => signOut()}>
                      <img src={require("../assets/images/logout-icon.svg").default} alt="" />
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Nav.Item>
            <Nav.Item as="li" className={`${pathname === "/Dashboard" && "active"}`}>
              <Nav.Link eventKey="1" as={Link} to="/Dashboard">
                <img src={require("../assets/images/dashboard-icon.svg").default} alt="" /> Dashboard
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li" className={`${pathname === "/PaymentHistory" && "active"}`}>
              <Nav.Link eventKey="2" as={Link} to="/PaymentHistory">
                <img src={require("../assets/images/payment-icon.svg").default} alt="" /> Payment Activity
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li" className={`${pathname === "/BankAccount" && "active"}`}>
              {!isForteEnabled && (
                <Nav.Link eventKey="3" as={Link} to="/BankAccount">
                  <img src={require("../assets/images/bank-account-icon.svg").default} alt="" /> Bank Account
                </Nav.Link>
              )}
            </Nav.Item>
            {user?.is_member !== 1 && (
              <Nav.Item as="li" className={`${pathname === "/Maintenance" && "active"}`}>
                <Nav.Link eventKey="4" as={Link} to="/Maintenance">
                  <img src={require("../assets/images/maintenance.svg").default} alt="" /> Maintenance
                </Nav.Link>
              </Nav.Item>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
  return (
    <>
      {loading && (
        <div className="loadingSpinner">
          <SpinnerLoading />
        </div>
      )}
      <div className="vertical-menu d-none d-lg-flex">
        <div className="sidebar">
          <div className="logo d-flex justify-content-center">
            <img className="cursor-pointer" onClick={() => navigation("/Dashboard")} src={LOGO} alt="" />
          </div>
          <div id="sidebar-menu">
            <ul className="leftmenu list-unstyled">
              <li className={`${pathname === "/Dashboard" && "active"}`}>
                <Link to="/Dashboard">
                  <img src={require("../assets/images/dashboard-icon.svg").default} alt="" /> Dashboard
                </Link>
              </li>
              <li className={`${pathname === "/PaymentHistory" && "active"}`}>
                <Link to="/PaymentHistory">
                  <img src={require("../assets/images/payment-icon.svg").default} alt="" /> Payment Activity
                </Link>
              </li>
              {!isForteEnabled && (
                <li className={`${pathname === "/BankAccount" && "active"}`}>
                  <Link to="/BankAccount">
                    <img src={require("../assets/images/bank-account-icon.svg").default} alt="" /> Bank Account
                  </Link>
                </li>
              )}
              {user?.is_member !== 1 && (
                <li className={`${pathname === "/Maintenance" && "active"}`}>
                  <Link to="/Maintenance">
                    <img src={require("../assets/images/maintenance.svg").default} alt="" /> Maintenance
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="user-info d-flex align-items-center">
          <img
            src={user?.profile_picture ? user.profile_picture : require("../assets/images/profileDummy.png").default}
            alt=""
            className="rounded-circle"
          />

          <Dropdown drop="end">
            <Dropdown.Toggle>
              {`${user?.first_name} ${String(user?.first_name + user?.last_name).length >= 16 ? "\n" : ""} ${
                user?.last_name
              }`}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => navigation("/MyAccount")}>
                <img src={require("../assets/images/account-icon.svg").default} alt="" />
                My Account
              </Dropdown.Item>
              <Dropdown.Item onClick={() => signOut()}>
                <img src={require("../assets/images/logout-icon.svg").default} alt="" />
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* mobile menu */}
      <MobileHeader />
    </>
  );
}
